import classNames from 'classnames';
import React, { memo, useCallback } from 'react';

import { t } from '~/helpers/localization';

import BuildingIcon from '~/UIKit/BuildingIcon/BuildingIcon';

import styles from './Header.module.scss';

import type { BUILDINGS } from '~/Actions/ActionSupply';

type IProps = {
  level: number;
  maxLevel: number;
  name: Nullable<BUILDINGS>;
  selectedBuildingId: Nullable<BUILDINGS>;
  title: string;
  dropSelection: () => void;
};

const Header: React.FC<IProps> = ({ level, maxLevel, name, selectedBuildingId, title, dropSelection }) => {
  const handleMouseOver = useCallback(() => {
    if (window?.tooltipProvider) {
      window.tooltipProvider.hide();
    }
  }, []);

  return (
    <div
      className={classNames(styles.buildingTopInfo, {
        [styles.isShow]: selectedBuildingId,
      })}
      onMouseOver={handleMouseOver}
    >
      <div className={styles.headerInlineWrapper}>
        <div className={styles.headerIconWrapper}>
          <BuildingIcon buildingId={name} />
        </div>
        <div className={styles.headerTitleWrapper}>
          <div>{title}</div>
          <div className={styles.headerUpgrades}>{t('Улучшений: %(level)s из %(maxLevel)s', { level, maxLevel })}</div>
        </div>
        <div className={styles.closeDialogButtonWrapper}>
          <div className={styles.closeDialogButton} onClick={dropSelection}>
            <div className={styles.closeDialogButtonIcon} />
            <span className={styles.closeDialogButtonText}>{t('Закрыть')}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(Header);
